import { Box } from '@mui/material';
import { format, parseISO } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { SttList, SttLabelDate } from '../all';
import { formatPriceByLocale } from '../../lib/utils';
import { getDateLocale } from '../../lib/dateLocale';

type Booking = {
    name: string;
    ini: string;
    end: string;
    price: number;
    totalPaid: number;
    priceShape: {
        currency?: string;
        locale?: string;
    };
};

type BookingDetail = {
    booking: Booking;
};

type Props = {
    bookings: BookingDetail[];
    onSelect: (bookingDetail: BookingDetail) => void;
};

/**
 *    Booking list
 *    ============
 *
 *    Props:
 *  Array bookings
 *  function onSelect
 *  bool showTotals
 *
 */
export function SttBookingList({
    bookings,
    onSelect,
}: Props): React.ReactElement {
    const { t } = useTranslation();

    // -----| Render |-----
    return (
        <SttList
            title={t('labels.bookings')}
            onSelect={onSelect}
            data={bookings.map((bookingDetail: any) => {
                const paid =
                    bookingDetail.booking.totalPaid >=
                    bookingDetail.booking.price;
                return {
                    caption: (
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            style={{ fontSize: 14 }}
                        >
                            <div>{bookingDetail.booking.name}</div>
                            <SttLabelDate date={bookingDetail.booking.ini} />
                            <div>{`${format(parseISO(bookingDetail.booking.ini), 'HH:mm', { locale: getDateLocale() })} - ${format(parseISO(bookingDetail.booking.end), 'HH:mm', { locale: getDateLocale() })}`}</div>
                            <div style={{ color: paid ? 'green' : 'red' }}>
                                {formatPriceByLocale(
                                    bookingDetail.booking.price,
                                    bookingDetail?.booking?.priceShape.currency,
                                )}
                            </div>
                        </Box>
                    ),
                    objToSelect: bookingDetail,
                };
            })}
        />
    );
}
